// extracted by mini-css-extract-plugin
module.exports = {"homeInfoContainer":"home_homeInfoContainer__1_37Z","homeInfoWrapperContent":"home_homeInfoWrapperContent__3EOzX","note":"home_note__3C6xU"};